// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.SendNotificationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SendNotificationRequestDto, SendNotificationResponseDto } from '../..';

export const SendNotificationWebApiHandler_sendNotification_Path = '/api/web/v1/sendNotification';

/**
 * Send notification
 */
export const SendNotificationWebApiHandler_sendNotification = (
  postData: SendNotificationRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendNotificationRequestDto, SendNotificationResponseDto>(
    {
      endpoint: SendNotificationWebApiHandler_sendNotification_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
